import { server_address } from '../../config';

// let server_address = 'http://127.0.0.1:8000/';
// let server_address='https://etymo-5cpb.onrender.com/';



export async function get_order_detail(amount) {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${server_address}razorpay_create_request/`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: token, amount: amount })

            }
        );
        const data = await response.json();
        if (data.message === 'success') {
            return [data.amount, data.order_id]
        } else {
            alert(data.message)
            return []
        }

    } catch (error) {
        console.log(error)
        alert("can't reach server")
        return []
    }

}